import * as React from "react";
const SvgFiRrSchool = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-school_svg__a)">
      <path
        fill="#062147"
        d="M19 6h-4.679A4 4 0 0 0 13 5.388V5l3.53-1.652a1 1 0 0 0 0-1.7l-3.2-1.5A1.637 1.637 0 0 0 11 1.636v3.752c-.474.12-.922.328-1.32.612H5a5.006 5.006 0 0 0-5 5v10a3 3 0 0 0 3 3h18a3 3 0 0 0 3-3V11a5.006 5.006 0 0 0-5-5m2.816 4h-2.159a3.02 3.02 0 0 1-2.121-.879l-1.122-1.12H19a3 3 0 0 1 2.816 2M5 8h2.586L6.464 9.121a3.02 3.02 0 0 1-2.121.88H2.184A3 3 0 0 1 5 8m8 14h-2v-3a1 1 0 0 1 2 0zm8 0h-6v-3a3 3 0 0 0-6 0v3H3a1 1 0 0 1-1-1v-9h2.343a4.97 4.97 0 0 0 3.535-1.465l2.708-2.707a2 2 0 0 1 2.828 0l2.708 2.707A4.97 4.97 0 0 0 19.657 12H22v9a1 1 0 0 1-1 1M7 15a1 1 0 0 1-1 1H5a1 1 0 0 1 0-2h1a1 1 0 0 1 1 1m0 4a1 1 0 0 1-1 1H5a1 1 0 0 1 0-2h1a1 1 0 0 1 1 1m13-4a1 1 0 0 1-1 1h-1a1 1 0 0 1 0-2h1a1 1 0 0 1 1 1m0 4a1 1 0 0 1-1 1h-1a1 1 0 0 1 0-2h1a1 1 0 0 1 1 1m-6-7a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-school_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSchool;
